import BaseEntity from "@/core/misc/BaseEntity";

class StickerType extends BaseEntity {

	public title: string;
	public color: string|null;

	private _isUpdated: boolean = false;
	private _isNew: boolean = false;

	constructor(id: number | null = null,
							title: string | null = null,
							color: string | null = null,
							editable: boolean = true,
							version: number | null = null,
	) {
		super();
		if (id !== null) this.id = id;
		if (title !== null) this.title = title;
		this.color = color;
		if (version !== null) this.version = version;
	}

	get isUpdated(): boolean {
		return this._isUpdated;
	}

	set isUpdated(value: boolean) {
		this._isUpdated = value;
	}

	get isNew(): boolean {
		return this._isNew;
	}

	set isNew(value: boolean) {
		this._isNew = value;
	}

	public static fromServer(data: any, stickerType = new StickerType()): StickerType {
		super.fromServer(data, stickerType);

		stickerType.title = data.title;
		stickerType.color = data.color;

		return stickerType;
	}

}

export default StickerType;
